
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import PlanSuperScoreWidget from "@/superscore/PlanSuperScoreWidget.vue"
import MetricTrendWidget from "@/superannuation/MetricTrendWidget.vue"
import CircularProgressBarWidget from "@/components/CircularProgressBarWidget/CircularProgressBarWidget.vue"
import {format} from "date-fns"

@Component({
  name: "DashboardPage",
  components: {
    Page,
    PlanSuperScoreWidget,
    MetricTrendWidget,
    CircularProgressBarWidget,
  },
})
export default class DashboardPage extends AbstractPage {
  private formatDisplay(displayDate: Date): string {
    return format(displayDate, "dd/MM/yyyy")
  }
}
